module.exports = __webpack_public_path__ + "static/media/headerIcon.ab047162.png";